export const LoadingFormDirective = {  
  update: function (el, binding) {
    const submitBtns = el.querySelectorAll('button[type="submit"]');

    submitBtns.forEach(button => {
      if(binding.value) {
        button.classList.add('loading');
        button.setAttribute('disabled', true);

      } else {
        button.classList.remove('loading');
        button.removeAttribute('disabled');
      }
    })
  }
}

export const LoadingButtonDirective = {  
  update: function (button, binding) {
    if(binding.value) {
      button.classList.add('loading');
      button.setAttribute('disabled', true);

    } else {
      button.classList.remove('loading');
      button.removeAttribute('disabled');
    }
  }
}